import _ from 'lodash'

import { ModalPortalPayloadMap, ModalPayload } from '@app/types'
import { InitializedModalPortals, ModalPortalHandlerInterface } from '../types'

import BaseModalHandler from './base-modal-handler'

export default class ModalCitizen
  extends BaseModalHandler
  implements ModalPortalHandlerInterface
{
  private initializedModalPortal: InitializedModalPortals

  constructor() {
    super()
    this.initializedModalPortal = {}
  }

  open<T extends keyof ModalPortalPayloadMap>(
    modalIdentifier: T,
    params?: ModalPayload<T>
  ): void {
    Object.keys(this.initializedModalPortal).forEach((key) => {
      const effectiveKey = key as keyof ModalPortalPayloadMap
      super._emitModalClosed(effectiveKey)
    })

    // Only one modal can ever be open in portal
    this.initializedModalPortal = {
      [modalIdentifier]: modalIdentifier,
    }

    this._emitModalOpened(modalIdentifier, params)
    this._addAppModalClass()
  }

  close<T extends keyof ModalPortalPayloadMap>(): T | null {
    if (_.isEmpty(this.initializedModalPortal)) {
      return null
    }

    const modalIdentifier = Object.keys(this.initializedModalPortal)[0] as T

    this._emitModalClosed(modalIdentifier)
    this._removeAppModalClass()
    delete this.initializedModalPortal[modalIdentifier]

    return modalIdentifier
  }
}
